import type { ApiError } from "@dfws/contracts";

export class ApiFailure extends Error {
  status: number;
  code: string;
  retryable: boolean;
  constructor(status: number, body: ApiError["error"] | null) {
    super(body?.message ?? `Request failed (${status})`);
    this.status = status;
    this.code = body?.code ?? "http_error";
    this.retryable = body?.retryable ?? status >= 500;
  }
}

let csrfToken = "";
export function setCsrf(token: string) {
  csrfToken = token;
}
export function getCsrf(): string {
  return csrfToken;
}

export async function api<T>(path: string, init: { method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE"; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  const method = init.method ?? "GET";
  const res = await fetch(`/api/v1${path}`, {
    method,
    credentials: "same-origin",
    headers: { Accept: "application/json", ...(init.body !== undefined ? { "Content-Type": "application/json" } : {}), ...(method !== "GET" ? { "X-CSRF-Token": csrfToken } : {}) },
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    signal: init.signal,
  });
  if (!res.ok) {
    let body: ApiError["error"] | null = null;
    try {
      body = ((await res.json()) as ApiError).error;
    } catch {
      /* not JSON */
    }
    throw new ApiFailure(res.status, body);
  }
  return (await res.json()) as T;
}
